import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../models/RootState';
import {
  addExchangeBet,
  getCurrencyTypeFromToken,
  addToMultiMarket,
  removeToMultiMarket,
  checkIncludeMultiMarket,
} from '../../store';
import './ExchFancyMarketsTable.scss';
import {
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tooltip,
  TableHead,
  Drawer,
} from '@material-ui/core';
import InfoImg from '../../assets/images/sportsbook/info.svg';
import { PlaceBetRequest } from '../../models/BsData';
import ExchOddBtn from '../ExchOddButton/ExchOddButton';
import { UserBet } from '../../models/UserBet';
import moment from 'moment';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import crossIcon from '../../assets/images/common/cross.svg';
import { EventDTO } from '../../models/common/EventDTO';
import { FancyMarketDTO } from '../../models/common/FancyMarketDTO';
import API from '../../api';
import Modal from '../../components/Modal/Modal';
import MarketTermsCondi from '../../components/MarketTermsCondi/MarketTermsCondi';
import FancyBookView from './FancyBookView/FancyBookView';
import Betslip from '../../components/ExchBetslip/ExchBetslip';
import { CURRENCY_TYPE_FACTOR } from '../../constants/CurrencyTypeFactor';
import Dialog from '@material-ui/core/Dialog';
import multipin from '../../assets/images/common/multipin.svg';
import removemultipin from '../../assets/images/common/removemultimarket.svg';
import { useHistory } from 'react-router-dom';
import { useMarketLocalState } from '../../hooks/storageHook';
import {
  isFancyMarketDisabled,
  isFancyMarketSuspended,
} from '../../store/exchangeSports/exchangeSportsSelectors';
import { IonIcon } from '@ionic/react';
import { CloseOutlined } from '@material-ui/icons';
import MarketTermsConFancy from '../MarketTermsCondi/MarketTermsConFancy';

type StoreProps = {
  eventData: EventDTO;
  fmData: FancyMarketDTO[];
  openBets: UserBet[];
  addExchangeBet: (data: PlaceBetRequest) => void;
  loggedIn: boolean;
  enableFancy: boolean;
  getFormattedMinLimit: (num: number) => string;
  getFormattedMaxLimit: (num: number) => string;
  bets: PlaceBetRequest[];
  isMultiMarket?: boolean;
  exposureMap: any;
  fancySuspended: boolean;
  fancyDisabled: boolean;
};

type OddsInfoMsg = {
  launch: boolean;
  oddsType: string;
  eventTypeID: string;
};

const FMTable: React.FC<StoreProps> = (props) => {
  const {
    isMultiMarket,
    eventData,
    fmData,
    bets,
    openBets,
    addExchangeBet,
    loggedIn,
    enableFancy,
    exposureMap,
    fancySuspended,
    fancyDisabled,
  } = props;

  const disabledStatus = [
    'closed',
    'suspended',
    'suspended-manually',
    'ball_running',
  ];
  const fancyCategoriesOrderExp = [
    { fancyCategory: 'OVERS', label: 'SESSIONS', enable: false, fmList: [] },
    {
      fancyCategory: 'BATSMAN',
      label: 'W/P MARKET',
      enable: false,
      fmList: [],
    },
    {
      fancyCategory: 'SINGLE_OVER',
      label: 'ONLY OVER',
      enable: false,
      fmList: [],
    },
    {
      fancyCategory: 'BALL_BY_BALL_SESSION',
      label: 'BALL BY BALL',
      enable: false,
      fmList: [],
    },
    { fancyCategory: 'ODD_EVEN', label: 'ODD/EVEN', enable: false, fmList: [] },
    {
      fancyCategory: 'THREE_SELECTIONS',
      label: 'XTRA MARKET',
      enable: false,
      fmList: [],
    },
  ];
  const [fancyCatgryHeaders, setFancyCatgryHeaders] = useState([
    { fancyCategory: 'OVERS', label: 'SESSIONS', enable: false },
    {
      fancyCategory: 'BATSMAN',
      label: 'W/P MARKET',
      enable: false,
    },
    {
      fancyCategory: 'SINGLE_OVER',
      label: 'ONLY OVER',
      enable: false,
    },
    {
      fancyCategory: 'BALL_BY_BALL_SESSION',
      label: 'BALL BY BALL',
      enable: false,
    },
    { fancyCategory: 'ODD_EVEN', label: 'ODD/EVEN', enable: false, },
    {
      fancyCategory: 'THREE_SELECTIONS',
      label: 'XTRA MARKET',
      enable: false,
    },
  ]);
  const [selFancyCatgry, setselFancyCatgry] = useState<string>('ALL');
  const [fancyEnabled, setFancyEnabled] = useState<boolean>(false);
  const [multiMarketData, setMultiMarketData] = useMarketLocalState();
  let history = useHistory();
  const [showBooksModal, setShowBooksModal] = useState<boolean>(false);
  const [fancyBookOutcomeId, setFancyBookOutcomeId] = useState<string>();
  const [fancyBookOutcomeName, setFancyBookOutcomeName] = useState<string>();
  const [infoDilalog, setInfoDialog] = useState<OddsInfoMsg>({
    launch: false,
    oddsType: null,
    eventTypeID: null,
  });
  const [marketLimits, setMarketLimits] = useState<any>({});
  const [enableFancyCategory, setEnableFancyCategory] =
    useState<boolean>(false);
  const [tabVal, setTabVal] = useState<number>(0);
  const [selectedRow, setSelectedRow] = useState<string>('');
  const [filteredFancyMarketsData, setFilteredFancyMarketsData] = useState<
    any[]
  >(fancyCategoriesOrderExp);
  const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];

  const fetchBetLimits = async (marketId: string, localMCategory: string) => {
    try {
      const payload = {
        competitionId: eventData.competitionId,
        eventId: eventData.eventId,
        marketId: marketId,
        marketType: 'FANCY',
        outcomeDesc: 'fancy',
        sessionId: marketId,
        sportId: eventData.sportId,
        mcategory: localMCategory,
      };

      let response;
      if (sessionStorage.getItem('jwt_token')) {
        response = await API.post('/bs/fetch-market-limits', payload, {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        });
      } else {
        response = await API.post('/bs/fetch-market-limits', payload);
      }
      if (response.status === 200 && response.data.success) {
        let limits = marketLimits;

        limits[marketId ? marketId : eventData.marketId] = {
          minStake: response.data.limits.minStake,
          maxStake: response.data.limits.maxStake,
          maxOdd: response.data.limits.maxOdd,
        };

        setMarketLimits((marketLimits) => {
          return {
            ...marketLimits,
            ...limits,
          };
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    let localData2 = fancyCategoriesOrderExp;
    if (selFancyCatgry === 'ALL') {
      fmData?.forEach((indvFM) => {
        localData2.forEach((indvObj) => {
          if (indvObj.fancyCategory === indvFM.category) {
            indvObj.fmList.push(indvFM);
            indvObj.enable = true;
          }
        });
      });
    } else {
      const sel = localData2.find((indv) => {
        return indv.fancyCategory === selFancyCatgry;
      });
      fmData?.forEach((indvFM) => {
        if (indvFM.category === sel.fancyCategory) {
          sel.fmList.push(indvFM);
          sel.enable = true;
        }
      });
    }
    setFilteredFancyMarketsData([...localData2]);
    fmData?.length > 0 ? setFancyEnabled(true) : setFancyEnabled(false);
  }, [selFancyCatgry, fmData]);

  useEffect(() => {
    for (const fm of fmData) {
      if (fm?.marketId && !fm?.marketLimits && !marketLimits[fm?.marketId]) {
        //setting a default value and the calling the fetch bet limits
        //so that fetch market limits is not multiple times for a single market
        marketLimits[fm?.marketId] = {
          minStake: 100,
          maxStake: 100,
          maxOdd: 4,
        };
        fetchBetLimits(fm?.marketId, fm.category);
      }
    }
   let localData = fancyCatgryHeaders;
    fmData?.forEach((fm) => {
      localData.forEach(indv => {
        if(fm.category === indv.fancyCategory) {
          indv.enable = true;
        }
      })
    })
    setFancyCatgryHeaders(localData);
  }, [fmData]);

  useEffect(() => {
    const elm = document.getElementById('mob-betslip');
    if (elm)
      elm?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
  }, [bets]);

  const handleMultiMarket = (
    competitionId,
    eventId,
    marketId,
    providerName,
    sportId,
    isAdd = true
  ) => {
    if (loggedIn) {
      if (isAdd) {
        addToMultiMarket(
          competitionId,
          eventId,
          marketId,
          providerName,
          sportId
        );
        marketId &&
          setMultiMarketData((prevState) => {
            return [
              ...prevState,
              {
                competitionId,
                eventId,
                marketId,
                providerName,
                sportId,
              },
            ];
          });
      } else {
        removeToMultiMarket(eventId, marketId);
        marketId &&
          setMultiMarketData((prevState) => {
            let data = [...prevState];
            const index = data?.findIndex(
              (itm) => itm.eventId === eventId && itm.marketId === marketId
            );
            index > -1 && data.splice(index, 1);
            return [...data];
          });
      }
    } else {
      history.push('/login');
    }
  };

  return (
    <>
      {!isMultiMarket ||
      checkIncludeMultiMarket(multiMarketData, 'fancy', eventData.eventId) ? (
        <div className="fm-table-ctn">
          <div className="fm-table-content table-ctn">
            <Accordion defaultExpanded={true}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon className="expand-icon" />}
                aria-controls="panel1a-content"
              >
                <div className="heading-title">
                  <span className="market-name">
                    {/* {!checkIncludeMultiMarket(
                      multiMarketData,
                      'fancy',
                      eventData?.eventId
                    ) ? (
                      <Tooltip
                        title="Add To Multi Markets "
                        placement="left-start"
                      >
                        <img
                          src={multipin}
                          alt="multipin"
                          className="multi-add-icon"
                          onClick={(e) => {
                            e.stopPropagation();
                            multiMarketData?.length < 10 &&
                              handleMultiMarket(
                                eventData?.competitionId,
                                eventData?.eventId,
                                'fancy',
                                eventData?.providerName,
                                eventData?.sportId,
                                true
                              );
                          }}
                        />
                      </Tooltip>
                    ) : (
                      <Tooltip
                        title="Remove From Multi Markets"
                        placement="left-start"
                      >
                        <img
                          src={removemultipin}
                          alt="multipin"
                          className="multi-remove-icon"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleMultiMarket(
                              eventData?.competitionId,
                              eventData?.eventId,
                              'fancy',
                              eventData?.providerName,
                              eventData?.sportId,
                              false
                            );
                          }}
                        />
                      </Tooltip>
                    )}{' '} */}
                   Fancy{' '}
                   <IonIcon
                          onClick={() =>
                            setInfoDialog({
                              launch: true,
                              oddsType: 'Fancy',
                              eventTypeID: eventData.sportId,
                            })
                          }
                          className="info-img"
                          src={InfoImg}
                        />
                            {/* <IonIcon
                          onClick={() =>
                            setInfoDialog({
                              launch: true,
                              oddsType: 'Fancy',
                              eventTypeID: eventData.sportId,
                            })
                          }
                          className="info-img"
                          src={InfoImg}
                        /> */}
                            </span>
                    <span className="event-name">
                   
                      {isMultiMarket ? eventData?.eventName : null}
                    </span>
              
                </div>
              </AccordionSummary>
              <AccordionDetails className="inplay-events-tbl-container">
                <TableContainer component={Paper}>
                  <Table className="fm-table">
                    <TableHead>
                      <TableRow>
                        <TableCell className="tabs-table-cell" colSpan={12}>
                          <div className="tabs-fancy">
                            {!fancyDisabled && fancyEnabled ? (
                              <span
                                className={tabVal === 0 ? 'sel-tab' : 'ind-tab'}
                                onClick={() => {
                                  setselFancyCatgry('ALL');
                                  setTabVal(0);
                                }}
                              >
                                <div> ALL</div>
                              </span>
                            ) : null}
                            {fancyCatgryHeaders.map((fc, index) => {
                              return fc.enable ? (
                                <span
                                  className={
                                    tabVal === index + 1 ? 'sel-tab' : 'ind-tab'
                                  }
                                  onClick={() => {
                                    setTabVal(index + 1);
                                    setselFancyCatgry(fc.fancyCategory);
                                  }}
                                >
                                  <div>{fc.label}</div>
                                </span>
                              ) : null;
                            })}
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <>
                        {!fancyDisabled ? (
                          <>
                            {filteredFancyMarketsData.map((indv) =>
                              indv.enable ? (
                                <>
                                  <FancyHeaderRow groupName={indv.label} />
                                  {indv.fmList.map((fMarket, index) => (
                                    <FancyMarketRow
                                      eventData={eventData}
                                      fMarket={fMarket}
                                      index={index}
                                      loggedIn={loggedIn}
                                      openBets={openBets}
                                      // getOpenBetsRiskValue={getOpenBetsRiskValue}
                                      // getRiskValue={getRiskValue}
                                      enableFancy={enableFancy}
                                      disabledStatus={disabledStatus}
                                      addExchangeBet={addExchangeBet}
                                      setShowBooksModal={() => {
                                        setFancyBookOutcomeId(fMarket.marketId);
                                        setFancyBookOutcomeName(
                                          fMarket.marketName
                                        );
                                        setShowBooksModal(true);
                                      }}
                                      exposureMap={exposureMap}
                                      minStake={
                                        fMarket?.marketLimits?.minStake
                                          ? fMarket?.marketLimits?.minStake
                                          : marketLimits[fMarket?.marketId]
                                              ?.minStake
                                      }
                                      maxStake={
                                        fMarket?.marketLimits?.maxStake
                                          ? fMarket?.marketLimits?.maxStake
                                          : marketLimits[fMarket?.marketId]
                                              ?.maxStake
                                      }
                                      oddLimit={
                                        fMarket?.marketLimits?.maxOdd?.toString()
                                          ? fMarket?.marketLimits?.maxOdd?.toString()
                                          : marketLimits[fMarket?.marketId]
                                              ?.maxOdd
                                      }
                                      outcomeOpenBets={openBets.filter(
                                        (b) =>
                                          b.marketType === 2 &&
                                          b.outcomeId === fMarket.marketId
                                      )}
                                      bets={bets}
                                      selectedRow={selectedRow}
                                      setSelectedRow={setSelectedRow}
                                      fancySuspended={fancySuspended}
                                      fancyDisabled={fancyDisabled}
                                    />
                                  ))}
                                </>
                              ) : null
                            )}
                          </>
                        ) : (
                          <TableRow>
                            <TableCell colSpan={3}>
                              <div className="fm-table-msg-text">
                                No Fancy Markets for this event
                              </div>
                            </TableCell>
                          </TableRow>
                        )}
                      </>
                    </TableBody>
                  </Table>
                </TableContainer>
              </AccordionDetails>
            </Accordion>
            <Modal
            open={infoDilalog.launch}
            closeHandler={() =>
              setInfoDialog({
                launch: false,
                oddsType: null,
                eventTypeID: null,
              })
            }
              customClass="light-bg-title"
            title="Rules"
              size="md"
          >
            {/* <div className="game-rules-header">
              <div className="game-rules-title">Game Rules</div>
              <div className="game-rules-close cursor" onClick={() => setInfoDialog({
                launch: false,
                oddsType: null,
                eventTypeID: null,
              })}><CloseOutlined /></div>
            </div> */}
            <MarketTermsConFancy
              oddsType={infoDilalog.oddsType}
              eventTypeID={infoDilalog.eventTypeID}
            />
            </Modal>
            <Dialog
              open={showBooksModal}
              onClose={() => {
                setShowBooksModal(false);
                setFancyBookOutcomeId(null);
              }}
              aria-labelledby="responsive-dialog-title"
              className="modal"
            >
              <div className="carw">
                <div className="arrow arrow-right">Book List</div>
              </div>
              <div className="modal-content">
                <div
                  className="go-corner"
                  onClick={() => {
                    setShowBooksModal(false);
                    setFancyBookOutcomeId(null);
                  }}
                >
                  <img src={crossIcon} alt="crossIcon" />
                </div>
                <FancyBookView
                  fancyBookOutcomeId={fancyBookOutcomeId}
                  exposureMap={
                    exposureMap &&
                    exposureMap &&
                    exposureMap[`${fancyBookOutcomeId}:${fancyBookOutcomeName}`]
                      ? exposureMap[
                          `${fancyBookOutcomeId}:${fancyBookOutcomeName}`
                        ]
                      : {}
                  }
                />
              </div>
            </Dialog>
          </div>
        </div>
      ) : null}
    </>
  );
};

type FancyHeaderRowProps = {
  groupName: string;
};

const FancyHeaderRow: React.FC<FancyHeaderRowProps> = (props) => {
  const { groupName } = props;
  const tableFields = [
    {
      key: 'groupName',
      Label: groupName,
      className: 'market-name-cell-head',
      align: 'left',
    },
    {
      key: 'odds-no',
      Label: 'No',
      className: 'odds-cell-head odds-no-cell',
      align: 'center',
    },
    {
      key: 'odds-yes',
      Label: 'Yes',
      className: 'odds-cell-head odds-yes-cell',
      align: 'center',
    },
    {
      key: 'limits',
      Label: '',
      className: 'odds-cell-head limits-cell',
      align: 'center',
    },
  ];

  return (
    <TableRow className="header-row">
      {tableFields.map((tF, index) => (
        <TableCell
          key={tF.key + index}
          align={tF.align === 'left' ? 'left' : 'center'}
          className={tF.className}
        >
          {tF.key === 'odds-no' || tF.key === 'odds-yes' ? (
            <div className={tF.key.toLowerCase() + '-cell'}>{tF.Label}</div>
          ) : (
            tF.Label
          )}
        </TableCell>
      ))}
    </TableRow>
  );
};

type FancyMarketRowProps = {
  eventData: EventDTO;
  fMarket: FancyMarketDTO;
  index: number;
  // getOpenBetsRiskValue: (fMarket: FancyMarketDTO) => string;
  // getRiskValue: (fMarket: FancyMarketDTO) => string;
  enableFancy: boolean;
  disabledStatus: string[];
  addExchangeBet: (data: PlaceBetRequest) => void;
  setShowBooksModal: () => void;
  outcomeOpenBets: UserBet[];
  bets: PlaceBetRequest[];
  selectedRow: string;
  setSelectedRow: (data) => void;
  openBets: UserBet[];
  loggedIn: boolean;
  exposureMap: any;
  maxStake: number;
  minStake: number;
  oddLimit: string;
  fancySuspended: boolean;
  fancyDisabled: boolean;
};

const FancyMarketRow: React.FC<FancyMarketRowProps> = (props) => {
  const {
    eventData,
    fMarket,
    index,
    enableFancy,
    disabledStatus,
    addExchangeBet,
    setShowBooksModal,
    outcomeOpenBets,
    bets,
    selectedRow,
    setSelectedRow,
    openBets,
    loggedIn,
    exposureMap,
    maxStake,
    minStake,
    oddLimit,
    fancySuspended,
    fancyDisabled,
  } = props;

  const isFancySuspended = (fMarketSuspended: boolean) => {
    return fancySuspended ? true : fMarketSuspended;
  };
  const isFancyDisabled = (fMarketDisabled: boolean) => {
    return fancyDisabled ? true : fMarketDisabled;
  };

  return (
    <>
      <TableRow key={'row-' + index}>
        <TableCell className="market-name-cell" key={'row-' + index + 'cell-1'}>
          <div className="market">{fMarket.marketName}</div>
          <div>
            {' '}
            {exposureMap &&
            exposureMap[`${fMarket.marketId}:${fMarket.marketName}`] ? (
              <Button
                className="fancy-book-btn"
                onClick={() => {
                  if (
                    exposureMap &&
                    exposureMap[`${fMarket.marketId}:${fMarket.marketName}`]
                  )
                    setShowBooksModal();
                }}
                disabled={
                  !(
                    exposureMap &&
                    exposureMap[`${fMarket.marketId}:${fMarket.marketName}`]
                  )
                }
              >
                Book
              </Button>
            ) : null}
          </div>

          {/* <div className="risk-value">{getRiskValue(fMarket)}</div> */}
        </TableCell>
        <TableCell className="odds-cell" key={'row-' + index + 'cell-2'}>
          <div className="odds-block">
            <ExchOddBtn
              mainValue={fMarket.layPrice}
              mainValueClass="runs"
              subValue={fMarket.laySize}
              subValueClass="odds"
              oddType="odds-no-cell"
              valueType="fancyMarketOdds"
              page="inner"
              disable={
                disabledStatus.includes(fMarket.status.toLowerCase()) ||
                isFancySuspended(fMarket.suspend) ||
                isFancyDisabled(fMarket.disable) ||
                !enableFancy ||
                moment(eventData.openDate).diff(moment(), 'minutes') >
                  60 * 24 * 2
              }
              onClick={() => {
                if (
                  !disabledStatus.includes(fMarket.status.toLowerCase()) ||
                  isFancySuspended(fMarket.suspend) ||
                  isFancyDisabled(fMarket.disable)
                ) {
                  setSelectedRow(fMarket.marketName + 'FM');
                  addExchangeBet({
                    sportId: eventData.sportId,
                    seriesId: eventData.competitionId,
                    seriesName: eventData.competitionName,
                    eventId: eventData.eventId,
                    eventName: eventData.eventName,
                    eventDate: eventData.openDate,
                    marketId: fMarket.marketId,
                    marketName: fMarket.marketName,
                    marketType: 'FANCY',
                    outcomeId: fMarket.marketId,
                    outcomeDesc: '@ ' + fMarket.layPrice,
                    betType: 'LAY',
                    amount: 0,
                    oddValue: fMarket.laySize,
                    sessionPrice: fMarket.layPrice,
                    oddLimt: oddLimit,
                    mcategory: fMarket.category,
                  });
                }
              }}
            />
          </div>
        </TableCell>
        <TableCell className="odds-cell" key={'row-' + index + 'cell-3'}>
          <div className="odds-block">
            <ExchOddBtn
              mainValue={fMarket.backPrice}
              mainValueClass="runs"
              subValue={fMarket.backSize}
              subValueClass="odds"
              oddType="odds-yes-cell"
              valueType="fancyMarketOdds"
              page="inner"
              disable={
                disabledStatus.includes(fMarket.status.toLowerCase()) ||
                isFancySuspended(fMarket.suspend) ||
                isFancyDisabled(fMarket.disable) ||
                !enableFancy ||
                moment(eventData.openDate).diff(moment(), 'minutes') >
                  60 * 24 * 2
              }
              onClick={() => {
                if (
                  !disabledStatus.includes(fMarket.status.toLowerCase()) ||
                  isFancySuspended(fMarket.suspend) ||
                  isFancyDisabled(fMarket.disable)
                ) {
                  setSelectedRow(fMarket.marketName + 'FM');
                  addExchangeBet({
                    sportId: eventData.sportId,
                    seriesId: eventData.competitionId,
                    seriesName: eventData.competitionName,
                    eventId: eventData.eventId,
                    eventName: eventData.eventName,
                    eventDate: eventData.openDate,
                    marketId: fMarket.marketId,
                    marketName: fMarket.marketName,
                    marketType: 'FANCY',
                    outcomeId: fMarket.marketId,
                    outcomeDesc: '@ ' + fMarket.backPrice,
                    betType: 'BACK',
                    amount: 0,
                    oddValue: fMarket.backSize,
                    sessionPrice: fMarket.backPrice,
                    oddLimt: oddLimit,
                    mcategory: fMarket.category,
                  });
                }
              }}
            />
          </div>
        </TableCell>

        <TableCell className="limits-cell">
          <div className="limits-data">
            <div className="row">Min: {minStake ? minStake : 0}</div>
            <div className="row">Max: {maxStake ? maxStake : 0}</div>
          </div>
        </TableCell>
        {disabledStatus.includes(fMarket.status.toLowerCase()) ||
        !enableFancy ||
        isFancySuspended(fMarket.suspend) ||
        isFancyDisabled(fMarket.disable) ? (
          <div className="disabled-odds-cell" key={'row-' + index + 'cell-4'}>
            {!enableFancy ||
            fMarket.status.toLowerCase().includes('suspended') ||
            isFancySuspended(fMarket.suspend) ||
            isFancyDisabled(fMarket.disable)
              ? 'SUSPENDED'
              : fMarket.status.replace('_', ' ')}
          </div>
        ) : null}
      </TableRow>

      {bets?.[0]?.marketName === fMarket.marketName &&
      selectedRow === fMarket.marketName + 'FM' ? (
        <TableRow className="mob-view" id="mob-betslip">
          <TableCell colSpan={4} className="betslip-cell">
            <Betslip mobileView={true} />{' '}
          </TableCell>
        </TableRow>
      ) : null}
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  const eventType = state.exchangeSports.selectedEventType;
  const competition = state.exchangeSports.selectedCompetition;
  const event = state.exchangeSports.selectedEvent;
  return {
    bets: state.exchBetslip.bets,
    openBets: state.exchBetslip.openBets,
    fancySuspended: isFancyMarketSuspended(
      state.exchangeSports.secondaryMarketsMap,
      event.id
    ),
    fancyDisabled: isFancyMarketDisabled(
      state.exchangeSports.secondaryMarketsMap,
      event.id
    ),
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    addExchangeBet: (data: PlaceBetRequest) => dispatch(addExchangeBet(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FMTable);
